import { render, staticRenderFns } from "./mob_basic.vue?vue&type=template&id=14278b3b&scoped=true"
import script from "./mob_basic.vue?vue&type=script&setup=true&lang=js"
export * from "./mob_basic.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob_basic.vue?vue&type=style&index=0&id=14278b3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14278b3b",
  null
  
)

export default component.exports